export const GET_TRANSPORTERS = 'GET_TRANSPORTERS';
export const TRANSPORTER_REQUEST = 'TRANSPORTER_REQUEST';
export const CREATE_TRANSPORTER = 'CREATE_TRANSPORTER';
export const UPDATE_TRANSPORTER = 'UPDATE_TRANSPORTER';
export const DELETE_TRANSPORTER = 'DELETE_TRANSPORTER';
export const TRANSPORTER_REQUEST_FAILURE = 'TRANSPORTER_REQUEST_FAILURE';